module.exports = __webpack_public_path__ + "img/verified.3238d845.jpg";